import { render, staticRenderFns } from "./CaptchaImg.vue?vue&type=template&id=f5e5b1de&scoped=true"
import script from "./CaptchaImg.vue?vue&type=script&lang=js"
export * from "./CaptchaImg.vue?vue&type=script&lang=js"
import style0 from "./CaptchaImg.vue?vue&type=style&index=0&id=f5e5b1de&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e5b1de",
  null
  
)

export default component.exports